<div class="dialog-main-container" [ngStyle]="{ padding: padding ? padding : '' }">
  <div class="dialog-information-container">
    <ng-container *ngIf="crossIcon; else titleOnly">
      <div class="dialog-title-row">
        <div class="dialog-title">{{ dialogTitle }}</div>
          <div class="dialog-cross-icon-box" (click)="closeDialog()">
          <img
            [src]="iconService.Icon.cross"
            width="16"
            height="16"
            alt="Close"
            class="dialog-cross-icon-img"
          />
        </div>
      </div>
    </ng-container>
    <ng-template #titleOnly>
      <div class="dialog-title">{{ dialogTitle }}</div>
    </ng-template>
    <div *ngIf="dialogDescription">
      <div class="dialog-description">{{ dialogDescription }}</div>
    </div>
    <div *ngIf="dialogDescriptionHTML">
      <div class="dialog-description" [innerHTML]="dialogDescriptionHTML"></div>
    </div>
    <div *ngIf="secondaryDescription">
      <div class="dialog-description" style="margin-top: 8px">{{ secondaryDescription }}</div>
    </div>
  </div>
  <div class="buttons-container">
    <div style="display: flex; flex-direction: row; gap: 8px" *ngIf="data">
      <flow-button *ngIf="!hideSecondaryButton" size="medium" [label]="secondaryButtonText" type="secondary" (click)="closeDialog()"></flow-button>
      <flow-button *ngIf="hidePrimaryButton" size="medium" [label]="secondaryButtonText" type="primary" specificWidth="140px" (click)="closeDialog()"></flow-button>
      <flow-button *ngIf="!hidePrimaryButton" size="medium" [label]="destructive ? destructiveText : buttonText" [type]="destructive ? 'destructive' : 'primary'" specificWidth="140px" (click)="submitQuickAction()"></flow-button>
    </div>
  </div>
</div>
